import React, { useEffect, useState } from 'react';
import HeaderNavbar from './MainHeader';
import SidebarOryza from './SidebarOryza';
import Sidebar from './SideNavigation';
import Header from './Header';
import Footer from './Footer';
import useCueAnimation from '../hooks/useCueAnimation';
import "../styles/style.css"
import '../styles/HeroSearchSection.css';
import '../bbkandy/css/hotale-style-custom.css'
import '../bbkandy/css/style-core.css'
import '../bbkandy/css/style.css'
import '../bbkandy/css/tourmaster-global-style-custom.css'
import '../bbkandy/css/tourmaster-room-style-custom.css'
import '../bbkandy/css/custom.css'
import '../styles/Dining.css'
import "../styles/d.css"
import "../bbkandy/css/dining.css"

const Dining = () => {


    useCueAnimation();



    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    const headingStyle = {
        fontFamily: "'Yellowtail', cursive",
        fontWeight: 400,
        fontSize: isMobile ? '40px' : '79px',
        lineHeight: isMobile ? '48px' : '95px',
        color: '#fff',
    };

    return (
        <>
            <Header />
            <HeaderNavbar />
            <SidebarOryza />
            <Sidebar />
            
            <HeroSection headingStyle={headingStyle} />
            
            <DiningContent />
            
            <Footer />
            
            <BackToTopButton />
        </>
    );
};

const HeroSection = ({ headingStyle }) => (
    <div className="hotale-page-title-wrap hotale-style-custom hotale-center-align"
        style={{
            backgroundImage: "url(/bbkandy/images/food/1-1.jpg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
    >
        <div className="hotale-header-transparent-substitute" style={{ height: "135px" }}></div>
        <div className="hotale-page-title-overlay"></div>
        <div className="hotale-page-title-container hotale-container">
            <div className="hotale-page-title-content hotale-item-pdlr">
                <h1 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font slidertitle"
                    style={headingStyle}>
                    Dining
                </h1>
            </div>
        </div>
    </div>
);

const DiningContent = () => {
        const [isMMobile, setIsMMobile] = useState(window.innerWidth <= 991);

useEffect(() => {
  const handleResize = () => {
    setIsMMobile(window.innerWidth <= 991);
  };

  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

const cardBodyStyle = {
  padding: isMMobile ? '25px 15px 5px 15px' : '45px 120px 20px 120px',
  backgroundColor: '#EEB660',
};
    const [activeTab, setActiveTab] = useState('breakfast');
    const [expandedSection, setExpandedSection] = useState('breakfast');

    const toggleSection = (section) => {
        setExpandedSection(expandedSection === section ? null : section);
    };

    return (
        <div className="gdlr-core-pbf-wrapper-content gdlr-core-js bbkandybg_m">
            <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container padding_top_bottom">
                <div className="gdlr-core-pbf-column gdlr-core-column-first"
                    id="gdlr-core-column-9"
                    style={{ width: "100%", float: "left" }}
                >
                    <div className="container" id="first_section" style={{marginBottom: "25px"}}>
                        <div className="tabs_menu" data-cue="slideInUp" data-delay="200">
                            <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />
                            
                            <div className="tab-content add_bottom_25" role="tablist">
                                <BreakfastTab 
isActive={activeTab === 'breakfast'}
  isExpanded={expandedSection === 'breakfast'}
  toggleSection={toggleSection}
  cardBodyStyle={cardBodyStyle}
                                />
                                <ALaCarteTab 
                                    isActive={activeTab === 'aLaCarte'} 
                                    isExpanded={expandedSection === 'aLaCarte'}
                                    toggleSection={toggleSection}
                                    cardBodyStyle={cardBodyStyle}
                                />
                                <DrinksTab 
                                    isActive={activeTab === 'drinks'} 
                                    isExpanded={expandedSection === 'drinks'}
                                    toggleSection={toggleSection}
                                    cardBodyStyle={cardBodyStyle}
                                />
                                <NonAlcoholicTab 
                                    isActive={activeTab === 'nonAlcoholic'} 
                                    isExpanded={expandedSection === 'nonAlcoholic'}
                                    toggleSection={toggleSection}
                                    cardBodyStyle={cardBodyStyle}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TabNavigation = ({ activeTab, setActiveTab }) => (
    <ul className="nav nav-tabs" role="tablist">
        <li className="nav-item">
            <button
                style={{ color: "#3A4A26" }}
                className={`nav-link ${activeTab === 'breakfast' ? 'active' : ''}`}
                onClick={() => setActiveTab('breakfast')}
                role="tab"
            >
                BREAKFAST
            </button>
        </li>
        <li className="nav-item">
            <button
                style={{ color: "#3A4A26" }}
                className={`nav-link ${activeTab === 'aLaCarte' ? 'active' : ''}`}
                onClick={() => setActiveTab('aLaCarte')}
                role="tab"
            >
                À LA CARTE
            </button>
        </li>
        <li className="nav-item">
            <button
                style={{ color: "#3A4A26" }}
                className={`nav-link ${activeTab === 'drinks' ? 'active' : ''}`}
                onClick={() => setActiveTab('drinks')}
                role="tab"
            >
                DRINKS
            </button>
        </li>
        <li className="nav-item">
            <button
                style={{ color: "#3A4A26" }}
                className={`nav-link ${activeTab === 'nonAlcoholic' ? 'active' : ''}`}
                onClick={() => setActiveTab('nonAlcoholic')}
                role="tab"
            >
                NON ALCOHOLIC
            </button>
        </li>
    </ul>
);

const BreakfastTab = ({ isActive, isExpanded, toggleSection, cardBodyStyle }) => (
    <div id="pane-A" className={`card tab-pane fade ${isActive ? 'show active' : ''}`} role="tabpanel" style={{backgroundColor : "#EEB660"}}>
        <div className="card-header" role="tab" id="heading-A">
            <h5>
               

                <button
  type="button"
  className="collapsed menu-toggle-link"
  data-bs-toggle="collapse"
  onClick={() => toggleSection('breakfast')}
  aria-expanded={isExpanded}
  aria-controls="collapse-A"
>
  BREAKFAST
</button>

            </h5>
        </div>
        <div 
            id="collapse-A" 
            className={`collapse ${isExpanded ? 'show' : ''}`} 
            role="tabpanel"
            aria-labelledby="heading-A"
            style={{transition: "all 0.5s ease"}}
        >
            <div className="card-body text-center bbk" style={cardBodyStyle}>
                <div className="row magnific-gallery add_top_30">
                    <MenuItem 
                        title="ENGLISH BREAKFAST"
                        description="2 Eggs (fried / poached / omelet ) | Baked bean | Grilled tomato | Spinach | Mushroom | Potato | Sausage or bacon | Toast | Butter | Jam"
                    />
                    <MenuItem 
                        title="EGG BENEDICT"
                        description="Coconut pol roti | Poached eggs | Bacon | Dhal | Coconut sambal | Hollandaise"
                    />
                    <MenuItem 
                        title="AVOCADO TOAST WITH POACHED EGG"
                        description="Avocado mashed | Spinach | Sourdough | Poached egg"
                    />
                    <MenuItem 
                        title="GRANOLA BOWL"
                        description="Habalapeti (Sri Lankan Oat) | Yoghurt | Fresh fruits | Kithul Treacle"
                    />
                    <MenuItem 
                        title="FRENCH TOAST"
                        description="Bread | Banana | Kithul Treacle | Ice Cream"
                    />
                    <MenuItem 
                        title="MILK RICE BOWL"
                        description="Milk rice | Baby jack fruit stew | Dhal curry"
                    />
                    <PriceDisclaimer />
                </div>
            </div>
        </div>
    </div>
);

const ALaCarteTab = ({ isActive, isExpanded, toggleSection, cardBodyStyle }) => (
    <div id="pane-B" className={`card tab-pane fade ${isActive ? 'show active' : ''}`} role="tabpanel"  style={{backgroundColor : "#EEB660"}}>
        <div className="card-header" role="tab" id="heading-B">
            <h5>
                

                

<button
  type="button"
  className="collapsed menu-toggle-link"
  data-bs-toggle="collapse"
  onClick={() => toggleSection('aLaCarte')}
  aria-expanded={isExpanded}
  aria-controls="collapse-B"
>
  Á LA CARTE
</button>

            </h5>
        </div>
        <div 
            id="collapse-B" 
            className={`collapse ${isExpanded ? 'show' : ''}`} 
            role="tabpanel"
            aria-labelledby="heading-B"
            style={{transition: "all 0.5s ease"}}
        >
            <div className="card-body text-center bbk" style={cardBodyStyle}>
                <div className="row magnific-gallery add_top_30">
                    <SectionTitle title="TO START WITH" />
                    <MenuItem2
                        title="ASHPLANT NACHO"
                        description="Fried ashplant | Avocado | Spiced sour cream | Mango salsa | Cheese"
                    />
                    <MenuItem2
                        title="MANIOC ARANCINI"
                        description="Manioc | Cheese | Spiced dip"
                    />
                    <MenuItem2 
                        title="CHICKEN SKEWERS"
                        description="Chicken | Coconut | Peanut dip"
                    />
                    <MenuItem2 
                        title="BRUSCHETTA"
                        description="Toast bread | Feta cheese | Basil | Tomato | Olive oil"
                    />
                    
                    <SectionTitle title="SALAD BOWLS" />
                    <MenuItem2 
                        title="SAUTEED PRAWNS WITH GOTUKOLA & MANGO"
                        description="Chicken | Croutons | Ice Berg Lettuce"
                    />
                    <MenuItem2 
                        title="GARDEN GREENS & WATERMELONS"
                        description="Greens | Cucumber | Seasonal Fruits"
                    />
                    
                    <SectionTitle title="MAINS" />
                    <MenuItem2
                        title="GRILLED BARRAMUNDI & CURRY GRAVY"
                        description="Barramundi | Lemongrass Rice | Spinach | Curry gravy"
                    />
                    <MenuItem2
                        title="POL ROTI WITH POLOS STEW"
                        description="Coconut roti | Young jackfruit | Dhal | Pol sambal"
                    />
                    <MenuItem2
                        title="CURRIED LOKU PRAWNS WITH FETTUCCINE"
                        description="Sri Lankan spices | Big prawns | Fettuccine | Coconut gravy"
                    />
                    <MenuItem2
                        title="ROAST PAAN PANINI"
                        description="Roast paan | Coconut sambal | Fries | Cheese | Ham | Fries"
                    />
                    <MenuItem2
                        title="EGG KOTTU ROTI"
                        description="Thin roti | Vegetables | Eggs"
                        additional="Your choice of skewers : Chicken | Seafood | Beef"
                    />
                    <MenuItem2
                        title="BBK BURGER CHICKEN"
                        description="Chicken breast | Cheese sauce | Pickle | Fries"
                    />
                    <MenuItem2
                        title="MUTTON & CHEESE WRAPPED"
                        description="Mutton | Cheese | Bell peppers | Thin roti | Sour cream"
                    />
                    <MenuItem2 
                        title="SPICED BEEF BURGER"
                        description="Beef | Onion | Cheese | Pickle | Fries"
                    />
                    
                    <SectionTitle title="DESSERTS" />
                    <MenuItem2
                        title="CHOCOLATE BROWNIE"
                        description="Chocolate | Cashew | Ice Cream"
                    />
                    <MenuItem2
                        title="BAKED BANANA BREAD WITH ICE CREAM"
                        description="Coffee Custard | Caramel"
                    />
                    <MenuItem2
                        title="SAGO & JAGGERY PUDDING"
                        description="Sago | Jaggery | Kithul treacle"
                    />
                    <MenuItem2
                        title="TROPICAL FRESH FRUIT BOWL"
                        description="Seasonal fruits"
                    />
                    <MenuItem2
                        title="YOUR CHOICE OF ICE CREAM"
                        description="Three scoops of : Vanilla | Chocolate | Strawberry"
                    />
                    
                    <PriceDisclaimer />
                </div>
            </div>
        </div>
    </div>
);

const DrinksTab = ({ isActive, isExpanded, toggleSection, cardBodyStyle }) => (
    <div id="pane-C" className={`card tab-pane fade ${isActive ? 'show active' : ''}`} role="tabpanel" style={{backgroundColor : "#EEB660"}}>
        <div className="card-header" role="tab" id="heading-C">
            <h5>
                

                

                                                <button
  type="button"
  className="collapsed menu-toggle-link"
  data-bs-toggle="collapse"
  onClick={() => toggleSection('drinks')}
  aria-expanded={isExpanded}
  aria-controls="collapse-C"
>
  DRINKS
</button>
            </h5>
        </div>
        <div 
            id="collapse-C" 
            className={`collapse ${isExpanded ? 'show' : ''}`} 
            role="tabpanel"
            aria-labelledby="heading-C"
            style={{transition: "all 0.5s ease"}}
        >
            <div className="card-body text-center bbk" style={cardBodyStyle}>
                <div className="row magnific-gallery add_top_30">
                    <SectionTitle title="COCKTAILS" />
                    <MenuItem2
                        title="BB FIZZ"
                        description="Gin | Ginger | Lemon grass | Sprite"
                    />
                    <MenuItem2
                        title="MOJITO (MELON / PASSION)"
                        description="Rum | Mint | Lime | Soda"
                    />
                    <MenuItem2
                        title="UDARATA JAMBOLA"
                        description="Vodka | Pomelo | Lime | Sprite"
                    />
                    <MenuItem2
                        title="HANTHANA BREEZE"
                        description="Gin | Passion | Orange | Lime | Soda"
                    />
                    <MenuItem2
                        title="TROPICAL PASSION"
                        description="Arrack | Passion | Pineapple | Mint | Soda"
                    />
                    
                    <SectionTitle title="BEER" />
                    <MenuItem2 title="LION LARGER 325ML" />
                    <MenuItem2 title="LION ICE 325ML" />
                    <MenuItem2 title="SOMERSBY APPLE 330ML" />
                    
                    <SectionTitle title="WINE" />
                    <SectionSubtitle title="BY THE GLASS" />
                    <MenuItem2 title="PARAISO WHITE (CHILE)" />
                    <MenuItem2 title="PARAISO RED (CHILE)" />
                    <MenuItem2 title="LAS CONDES ROSE (CHILE)" />
                    
                    <SectionSubtitle title="BY THE BOTTLE" />
                    <MenuItem2 title="PARAISO WHITE (CHILE)" />
                    <MenuItem2 title="YELLOW TAIL S.BLANC (AUSTRALIA)" />
                    <MenuItem2 title="S.M. PINAT GRIGIO (ITALY)" />
                    <MenuItem2 title="LAS CONDES ROSE (CHILE)" />
                    <MenuItem2 title="PARAISO RED (CHILE)" />
                    <MenuItem2 title="TALL HORSE PINOTAGE (SOUTH AFRICA)" />
                    
                    <PriceDisclaimer />
                </div>
            </div>
        </div>
    </div>
);

const NonAlcoholicTab = ({ isActive, isExpanded, toggleSection, cardBodyStyle }) => (
    <div id="pane-D" className={`card tab-pane fade ${isActive ? 'show active' : ''}`} role="tabpanel" style={{backgroundColor : "#EEB660"}}>
        <div className="card-header" role="tab" id="heading-D">
            <h5 style={{fontFamily: "Poppins,sans-serif", fontWeight : "700", fontSize:"18",lineHeight : "22px "}}>
                

                

                                                <button
  type="button"
  className="collapsed menu-toggle-link"
  data-bs-toggle="collapse"
  onClick={() => toggleSection('nonAlcoholic')}
  aria-expanded={isExpanded}
  aria-controls="collapse-D"
>
  NON ALCOHOLIC
  </button>

                                                
            </h5>
        </div>
        <div 
            id="collapse-D" 
            className={`collapse ${isExpanded ? 'show' : ''}`} 
            role="tabpanel"
            aria-labelledby="heading-D"
            style={{transition: "all 0.5s ease"}}
        >
            <div className="card-body text-center bbk" style={cardBodyStyle}>
                <div className="row magnific-gallery add_top_30">
                    <SectionTitle title="CAFÉ" />
                    <MenuItem2 title="AMERICANO" />
                    <MenuItem2 title="ESPRESSO / D.ESPRESSO" />
                    <MenuItem2 title="CAPPUCCINO | CAFÉ LATTE" />
                    <MenuItem2 title="HOT CHOCOLATE" />
                    <MenuItem2 
                        title="POT OF TEA"
                        description="English | Green | Earl Grey"
                    />
                    
                    <SectionTitle title="NON - ALCOHOLIC BEVERAGES" />
                    <MenuItem2 title="FRESH JUICES" />
                    <MenuItem2 title="LIME & SODA" />
                    <MenuItem2 title="LIME JUICE" />
                    <MenuItem2 title="KING COCONUT" />
                    <MenuItem2 title="AVOCADO | MANGO | MIX FRUIT" />
                    <MenuItem2 
                        title="VIRGIN MOJITO"
                        description="(Watermelon / Pineapple / Passion)"
                    />
                    <MenuItem2 
                        title="FRESCO"
                        description="Ginger | Lime | Mint | Ginger Ale"
                    />
                    <MenuItem2 
                        title="CEYLON TEA"
                        description="Tea | Ginger | Mint | Cinnamon | Simple Syrup"
                    />
                    <MenuItem2 
                        title="GREEN MINT TEA"
                        description="Green Tea | Lime | Mint | Honey"
                    />
                    <MenuItem2 
                        title="CARBONATED DRINK"
                        description="(Sprite / Coke / D.Coke / Soda / Tonic / Ginger Ale)"
                    />
                    
                    <PriceDisclaimer />
                </div>
            </div>
        </div>
    </div>
);

const MenuItem = ({ title, description, additional }) =>{
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    return (
    <div className="col-md-6 col-sm-12" data-cue="slideInUp" data-delay="50">
        <div className="menu_title" >
            <h4 style={{fontFamily: "Poppins,sans-serif", fontWeight : "700", fontSize: isMobile ? '20px' : '28px',lineHeight : isMobile ? '24px' : '34px'}}>{title}</h4>
        </div> 
        {description && <p style={{fontFamily: "Poppins,sans-serif", fontWeight : "400", ffontSize: isMobile ? '15px' : '17px',lineHeight : isMobile ? '26px' : '29px', color: "#3a4a26"}}>{description}</p>}
        {additional && <p className="additional-info" style={{fontFamily: "Poppins,sans-serif", fontWeight : "400", fontSize:"17px",lineHeight : "29px", color: "#3a4a26"}}>{additional}</p>}
    </div>
);
}

const MenuItem2 = ({ title, description, additional }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreen(); // Initial check
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    const titleStyle = {
        fontFamily: "Poppins, sans-serif",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "30px",
        color: "#3a4a26"
    };

    const textStyle = {
        fontFamily: "Poppins, sans-serif",
        fontWeight: 400,
        fontSize: isMobile ? "13px" : "17px",
        lineHeight: isMobile ? "22px" : "29px",
        color: "#3a4a26"
    };

    return (
        <div className="col-6 menu_item_padding" data-cue="fadeIn" data-delay="100">
            <div className="menu_title menu_item_size" style={titleStyle}>
                {title}
            </div>
            {description && <p style={textStyle}>{description}</p>}
            {additional && <p className="additional-info" style={textStyle}>{additional}</p>}
        </div>
    );
};





const SectionTitle = ({ title }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    return(
    <div className="col-12" data-cue="slideInUp" data-delay="50">
        <div className="title text-center mb-5" >
            <h2 style={{fontFamily: "Poppins,sans-serif", fontWeight : "500", fontSize: isMobile ? '40px' : '48px',lineHeight : "58px "}}>{title}</h2>
        </div>
    </div>
); }

const SectionSubtitle = ({ title }) => (
    
    <div className="col-12" data-cue="slideInUp" data-delay="50">
        <div className="title text-center mb-5">
            <h4 style={{fontFamily: "Poppins,sans-serif", fontWeight : "700", fontSize:"28px",lineHeight : "34px "}}>{title}</h4>
        </div>
    </div>
);


const PriceDisclaimer = () => (
    <div className="col-12" style={{ paddingTop: "30px" }} data-cue="slideInUp" data-delay="50">
        <h5>ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</h5>
    </div>
);

const BackToTopButton = () => (
    <div className="progress-wrap">
        <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
        >
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
);

export default Dining;